import { useAuthState } from '@kaa/auth/common';
import { LocationProvider } from '@reach/router';
import React, { useRef } from 'react';
import { AuthContext } from '../../types';
import { sendVirtualPageViewEvent } from '../../utils/google-analytics';

export const PageViewGTMListener = () => {
  const previous = useRef<string | null>(null);
  const { selectedCustomerId } = useAuthState<AuthContext>();
  return (
    <LocationProvider>
      {({ location }) => {
        if (previous.current !== location.pathname) {
          previous.current = location.pathname;
          sendVirtualPageViewEvent(location.pathname, {
            customerId: selectedCustomerId,
            modDefaultPathname: false,
          });
        }
        return null;
      }}
    </LocationProvider>
  );
};
